import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNoWifi = () => {
  return (
    <g>
      <path d="m13.1025 7.7486a.7366.7366 0 0 1 -.5231-.2167 6.4767 6.4767 0 0 0 -9.1589 0 .74.74 0 0 1 -1.0461-1.0462 7.9558 7.9558 0 0 1 11.2511 0 .74.74 0 0 1 -.5231 1.2629z" />
      <path d="m15.1466 4.5861a.7366.7366 0 0 1 -.5231-.2167 9.3674 9.3674 0 0 0 -13.2471 0 .74.74 0 0 1 -1.0464-1.0461 10.8465 10.8465 0 0 1 15.3393 0 .74.74 0 0 1 -.5231 1.2629z" />
      <path d="m5.534 15.8536a.74.74 0 0 1 -.5231-1.2629l4.932-4.932a.74.74 0 0 1 1.0461 1.0461l-4.932 4.932a.7366.7366 0 0 1 -.523.2168z" />
      <path d="m10.466 15.8536a.7366.7366 0 0 1 -.5231-.2167l-4.932-4.932a.74.74 0 0 1 1.0462-1.0461l4.932 4.932a.74.74 0 0 1 -.5231 1.2629z" />
    </g>
  );
};

export default withIcon(IconNoWifi);
